var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, Button, Checkbox, CircularProgress, debounce, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField, Typography } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { PatternFormat } from 'react-number-format';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { useCreateClientMutation, useLazyGetClientQuery, useLazyGetListByNameQuery } from '../../../../application/features/clients/client-api';
import { useGetAllCompaniesQuery } from '../../../../application/features/companies/company-api';
import { useLazyGetLocationQuery, useLazySearchAddressLocationQuery } from '../../../../application/features/pdok/pdok-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
var AddClient = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _c = __read(useState([]), 2), currentCompanies = _c[0], setCurrentCompanies = _c[1];
    var _d = __read(useState(''), 2), clientSearchTerm = _d[0], setClientSearchTerm = _d[1];
    var _e = __read(useState(''), 2), locationSearchTerm = _e[0], setLocationSearchTerm = _e[1];
    var _f = __read(useLazyGetLocationQuery(), 2), triggerGetLocation = _f[0], isLocationDetailFetching = _f[1].isFetching;
    var _g = useGetAllCompaniesQuery({
        filterByCompany: true
    }), _h = _g.data, allCompanies = _h === void 0 ? [] : _h, isCompaniesLoading = _g.isLoading, isCompaniesFetching = _g.isFetching;
    var _j = __read(useLazySearchAddressLocationQuery(), 2), triggerSearchLocation = _j[0], _k = _j[1], _l = _k.data, locations = _l === void 0 ? [] : _l, isLocationsFetching = _k.isFetching;
    var _m = __read(useCreateClientMutation(), 2), triggerCreateClient = _m[0], _o = _m[1], isLoading = _o.isLoading, isSuccess = _o.isSuccess;
    var _p = __read(useLazyGetListByNameQuery(), 2), getClients = _p[0], _q = _p[1], _r = _q.data, clients = _r === void 0 ? [] : _r, isClientsFetching = _q.isFetching;
    var _s = __read(useLazyGetClientQuery(), 2), triggerGetClient = _s[0], _t = _s[1], client = _t.data, isFetching = _t.isFetching;
    var _u = useForm({
        defaultValues: {
            name: '',
            address: undefined,
            location: undefined,
            companies: [],
            contactPersonName: '',
            contactPersonPhoneNumber: ''
        }
    }), control = _u.control, handleSubmit = _u.handleSubmit, setValue = _u.setValue, reset = _u.reset, errors = _u.formState.errors;
    useEffect(function () {
        if (currentCompany && currentUser.roleCategory !== RoleCategories.SuperAdmin) {
            setValue('companies', [currentCompany.id], { shouldValidate: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCompany, currentUser]);
    useEffect(function () {
        if (currentUser.roleCategory === RoleCategories.SuperAdmin)
            setCurrentCompanies(allCompanies);
    }, [allCompanies, currentUser]);
    useEffect(function () {
        if (client && currentCompany) {
            if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin) {
                var id = client.id, contactPersonName = client.contactPersonName, contactPersonPhoneNumber = client.contactPersonPhoneNumber, name_1 = client.name, streetName = client.streetName, streetNumber = client.streetNumber, postCode = client.postCode, city = client.city, country = client.country, latitude = client.latitude, longitude = client.longitude, companies = client.companies;
                var location_1 = [
                    !streetNumber && !postCode ? "".concat(streetName, ",") : streetName,
                    streetNumber ? "".concat(streetNumber, ",") : null,
                    postCode ? "".concat(postCode) : null,
                    city
                ]
                    .filter(Boolean)
                    .join(' ');
                reset({
                    id: id,
                    contactPersonName: contactPersonName,
                    contactPersonPhoneNumber: contactPersonPhoneNumber,
                    name: name_1,
                    location: {
                        isFakeId: true,
                        id: nanoid(),
                        weergavenaam: location_1
                    },
                    address: {
                        city: city,
                        country: country,
                        postCode: postCode,
                        latitude: latitude,
                        longitude: longitude,
                        streetName: streetName,
                        streetNumber: streetNumber
                    },
                    companies: companies.map(function (company) { return company.id; })
                });
            }
            else {
                var id = client.id, contactPersonName = client.contactPersonName, contactPersonPhoneNumber = client.contactPersonPhoneNumber, name_2 = client.name, streetName = client.streetName, streetNumber = client.streetNumber, postCode = client.postCode, city = client.city, country = client.country, latitude = client.latitude, longitude = client.longitude;
                var location_2 = [
                    !streetNumber && !postCode ? "".concat(streetName, ",") : streetName,
                    streetNumber ? "".concat(streetNumber, ",") : null,
                    postCode ? "".concat(postCode) : null,
                    city
                ]
                    .filter(Boolean)
                    .join(' ');
                reset({
                    id: id,
                    contactPersonName: contactPersonName,
                    contactPersonPhoneNumber: contactPersonPhoneNumber,
                    name: name_2,
                    location: {
                        isFakeId: true,
                        id: nanoid(),
                        weergavenaam: location_2
                    },
                    address: {
                        city: city,
                        country: country,
                        postCode: postCode,
                        latitude: latitude,
                        longitude: longitude,
                        streetName: streetName,
                        streetNumber: streetNumber
                    },
                    companies: [currentCompany.id]
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client, currentCompany]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.createSuccess', 'common.client'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            handleCloseDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var getClientSearchResults = useMemo(function () {
        return debounce(function (clientSearchTerm) {
            if (clientSearchTerm)
                getClients(clientSearchTerm);
        }, 1000);
    }, [getClients]);
    useEffect(function () {
        getClientSearchResults(clientSearchTerm);
    }, [getClientSearchResults, clientSearchTerm]);
    var getLocationSearchResults = useMemo(function () {
        return debounce(function (locationSearchTerm) {
            if (locationSearchTerm)
                triggerSearchLocation(locationSearchTerm);
        }, 1000);
    }, [triggerSearchLocation]);
    useEffect(function () {
        getLocationSearchResults(locationSearchTerm);
    }, [getLocationSearchResults, locationSearchTerm]);
    function areDtosEqual(clientList, createClient) {
        if (clientList.name !== createClient.name)
            return false;
        if (clientList.latitude !== createClient.address.latitude ||
            clientList.longitude !== createClient.address.longitude) {
            return false;
        }
        var streetName = clientList.streetName, streetNumber = clientList.streetNumber, postCode = clientList.postCode, city = clientList.city, country = clientList.country, latitude = clientList.latitude, longitude = clientList.longitude;
        var address = createClient.address;
        if (streetName !== address.streetName ||
            streetNumber !== address.streetNumber ||
            postCode !== address.postCode ||
            city !== address.city ||
            country !== address.country ||
            latitude !== address.latitude ||
            longitude !== address.longitude) {
            return false;
        }
        if (clientList.contactPersonName !== createClient.contactPersonName ||
            clientList.contactPersonPhoneNumber !== createClient.contactPersonPhoneNumber) {
            return false;
        }
        return true;
    }
    var onLocationChange = function (value) {
        if (value) {
            triggerGetLocation(value.id)
                .unwrap()
                .then(function (location) {
                var coordinates = location.centroide_ll.match(/POINT\(([^ ]+) ([^)]+)\)/);
                if (coordinates) {
                    setValue('address.longitude', Number.parseFloat(coordinates[1]));
                    setValue('address.latitude', Number.parseFloat(coordinates[2]));
                }
                if (location.huisnummer)
                    setValue('address.streetNumber', location.huisnummer.toString());
                setValue('address.postCode', location.postcode);
                setValue('address.streetName', location.straatnaam);
                setValue('address.city', location.woonplaatsnaam);
                setValue('address.country', 'Netherlands');
            });
        }
    };
    var getExistingClient = function (clientId) {
        triggerGetClient(clientId);
    };
    var handleCreateClient = function (newClient) {
        if (client) {
            var isEqual = areDtosEqual(client, newClient);
            if (!isEqual)
                newClient.id = null;
        }
        triggerCreateClient(newClient);
    };
    var handleCloseDialog = function () {
        reset();
        onClose();
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'xs', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [tWithFunction('actions.addFunction', 'common.client'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: handleCloseDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    pb: 4
                }, children: _jsx(Box, { component: 'form', noValidate: true, mt: 1, children: _jsxs(Grid, { container: true, spacing: 1.5, children: [_jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'name', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.name')
                                        },
                                        maxLength: {
                                            value: 256,
                                            message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), fullWidth: true, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, options: clients, loading: isClientsFetching, disabled: isLoading || isFetching, value: clients.find(function (client) { return client.id === value; }), onChange: function (_, newValue) {
                                                        if ((newValue === null || newValue === void 0 ? void 0 : newValue.id) === 'new') {
                                                            setValue('name', newValue.name, { shouldValidate: true });
                                                        }
                                                        else {
                                                            onChange(newValue === null || newValue === void 0 ? void 0 : newValue.id);
                                                            if (newValue === null || newValue === void 0 ? void 0 : newValue.id)
                                                                getExistingClient(newValue === null || newValue === void 0 ? void 0 : newValue.id);
                                                        }
                                                    }, onInputChange: function (event, value) {
                                                        if ((event === null || event === void 0 ? void 0 : event.type) === 'change') {
                                                            setClientSearchTerm(value);
                                                        }
                                                    }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option.id }), option.id === 'new' ? (_jsxs("span", { children: [_jsx("strong", { children: translate('actions.add') }), " ", "\"".concat(option.name, "\"")] })) : (_jsx("span", { children: "".concat(option.name, ", ").concat(option.city) })))); }, filterOptions: function (options, params) {
                                                        var filtered = options;
                                                        var inputValue = params.inputValue;
                                                        var isExisting = options.some(function (option) { return inputValue === option.name; });
                                                        if (inputValue !== '' && !isExisting) {
                                                            filtered.push({
                                                                id: 'new',
                                                                name: inputValue,
                                                                streetName: '',
                                                                streetNumber: '',
                                                                postCode: '',
                                                                city: '',
                                                                country: ''
                                                            });
                                                        }
                                                        return filtered;
                                                    }, renderInput: function (params) { return (_jsx(TextField, __assign({ autoFocus: true, placeholder: tWithFunction('actions.searchFunction', 'common.name'), error: !!errors.name }, params, { label: translate('common.name'), slotProps: {
                                                            input: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(Fragment, { children: [isClientsFetching ? (_jsx(CircularProgress, { color: 'inherit', size: 20 })) : null, params.InputProps.endAdornment] })) })
                                                        } }))); }, sx: {
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '8px',
                                                            '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                padding: '3.5px 4px 3.5px 8px'
                                                            }
                                                        }
                                                    } }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin && (_jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'companies', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.company')
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, disabled: isLoading || isCompaniesLoading, loading: isCompaniesFetching, options: currentCompanies.filter(function (company) { return company.isActive === true; }), value: currentCompanies.filter(function (company) { return value.includes(company.id); }), isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, disableCloseOnSelect: true, slotProps: { chip: { size: 'small', variant: 'soft' } }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.companies'), error: !!errors.companies }))); }, onChange: function (_, value) {
                                                        onChange(value.map(function (val) { return val.id; }));
                                                    }, renderOption: function (props, option, _a) {
                                                        var selected = _a.selected;
                                                        return (_createElement("li", __assign({}, props, { key: option.id }),
                                                            _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                            option.name));
                                                    }, sx: {
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '8px',
                                                            '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                padding: '3.5px 4px 3.5px 8px'
                                                            }
                                                        }
                                                    } }), _jsx(FormHelperText, { error: true, children: (_b = errors.companies) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) })), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'location', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.location')
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), fullWidth: true, disabled: isLoading || isFetching, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.weergavenaam; }, options: locations, loading: isLocationsFetching, onChange: function (_, value) {
                                                        onChange(value);
                                                        onLocationChange(value);
                                                    }, onInputChange: function (event, value) {
                                                        if ((event === null || event === void 0 ? void 0 : event.type) === 'change') {
                                                            setLocationSearchTerm(value);
                                                        }
                                                    }, value: value || null, renderInput: function (params) { return (_jsx(TextField, __assign({ placeholder: tWithFunction('actions.searchFunction', 'common.location') }, params, { label: translate('common.location'), slotProps: {
                                                            input: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(Fragment, { children: [isLocationsFetching ? (_jsx(CircularProgress, { color: 'inherit', size: 20 })) : null, params.InputProps.endAdornment] })) })
                                                        }, error: !!errors.location }))); }, sx: {
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '8px',
                                                            '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                padding: '3.5px 4px 3.5px 8px'
                                                            }
                                                        }
                                                    } }), _jsx(FormHelperText, { error: true, children: (_b = errors.location) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Typography, { variant: 'overline', color: 'text/primary', fontWeight: 700, children: translate('clients.contactPerson').toUpperCase() }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'contactPersonName', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.name')
                                        },
                                        maxLength: {
                                            value: 256,
                                            message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { margin: 'dense', disabled: isLoading || isFetching, label: translate('common.name'), type: 'text', onChange: onChange, value: value, fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } }, error: !!errors.contactPersonName }), _jsx(FormHelperText, { error: true, children: (_b = errors.contactPersonName) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), _jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'contactPersonPhoneNumber', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.phone')
                                        },
                                        maxLength: {
                                            value: 20,
                                            message: translate('validations.maximumCharactersAllowed', { count: 20 })
                                        },
                                        pattern: {
                                            value: /^\+31(?!0)\d{9}$/,
                                            message: translate('validations.invalidFormat')
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(PatternFormat, { allowEmptyFormatting: true, customInput: TextField, format: '+31#########', isAllowed: function (values) {
                                                        return (!values.value ||
                                                            (values.floatValue !== undefined && values.floatValue > 0));
                                                    }, margin: 'dense', disabled: isLoading || isFetching, onChange: onChange, value: value, label: translate('common.phone'), type: 'tel', fullWidth: true, slotProps: { input: { sx: { borderRadius: '8px' } } }, error: !!errors.contactPersonPhoneNumber }), _jsx(FormHelperText, { error: true, children: (_b = errors.contactPersonPhoneNumber) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) })] }) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', onClick: handleCloseDialog, disabled: isLoading || isFetching, children: translate('actions.cancel') }), _jsx(Button, { size: 'medium', variant: 'contained', color: 'inherit', onClick: handleSubmit(handleCreateClient), disabled: isLoading || isLocationDetailFetching || isFetching, children: tWithFunction('actions.addFunction', 'common.client') })] })] }));
};
export default AddClient;
